import moment from 'moment';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IExpressOrderingOutlet } from '../models/i-express-ordering-outlet.interface';
import { IDayDefinition } from '../models/i-outlet-calendar-day';

@Injectable()
export class OutletOrderTimingManager {
  constructor(private _translate: TranslateService) {
  }

  public getOutletEarliestTimeText(outlet: IExpressOrderingOutlet) {
    return this._translate.instant('bakerySite.expressOrdering.chooseOutlet.earliestPickUp', {
      time: this.getOutletEarliestPickUpTime(outlet).toLowerCase()
    });
  }

  public getOutletEarliestPickUpTime(outlet: IExpressOrderingOutlet) {
    const { minOrderPickupTime } = outlet.orderTiming;
    const minDate = moment.parseZone(minOrderPickupTime).format('YYYY-MM-DD');
    const isToday = minDate === moment().format('YYYY-MM-DD');
    const isTomorrow = minDate === moment().add(1, 'day').format('YYYY-MM-DD');


    if (isToday) {
      return this.getDisplayingTimeForToday(outlet);
    } else if (isTomorrow) {
      return this._translate.instant('bakerySite.expressOrdering.chooseOutlet.orderTiming.tomorrowAt', {
        time: moment.parseZone(minOrderPickupTime).format('HH:mm')
      });
    } else {
      return this._translate.instant('bakerySite.expressOrdering.common.dayAtTime', {
        time: moment.parseZone(minOrderPickupTime).format('HH:mm'),
        day: moment.parseZone(minOrderPickupTime).format('D. MMM')
      });
    }
  }

  public getDayDefinition(date): IDayDefinition {
    const isToday = moment(date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');
    const isTomorrow = moment(date).format('YYYY-MM-DD') === moment().add(1, 'day').format('YYYY-MM-DD');
    const isAnotherDay = !isToday && !isTomorrow;
    return { isToday, isTomorrow, isAnotherDay };
  }

  public getDisplayingTimeForToday(outlet: IExpressOrderingOutlet) {
    const { hours, minutes } = this.getTimeFromDeadline(outlet.orderTiming);
    const parts = [];
    if (hours) {
      parts.push(hours + ' ' + this._translate.instant('common.timing.hours', { hours }));
    }
    if (minutes) {
      parts.push(minutes + ' ' + this._translate.instant('common.timing.minutes', { minutes }));
    }
    return this._translate.instant('common.timing.inTime', { time: parts.join(' ') });
  }

  public getTimeFromDeadline(orderTiming): { hours: number, minutes: number } {
    const { finishOrderDeadline, minOrderPickupTime } = orderTiming;
    const diffDeadline = moment(minOrderPickupTime).diff(moment(), 'minutes');

    /**
     * It is necessary to get earliest pick-up, and it will get by difference between outlet minOrderPickupTime
     * and now time (at this moment). But they are always would diff not only hours and minutes but seconds
     * (i.e. finishOrderDeadline=120 minutes, and difference between outlet minOrderPickupTime and now time would be 119 minutes 43 seconds)
     * so conditions below should set right order deadline
     * */
    let deadline;
    if (diffDeadline <= finishOrderDeadline) {
      deadline = finishOrderDeadline;
    } else {
      const deadlineTail = diffDeadline % 10;
      deadline = deadlineTail ? diffDeadline + 10 - deadlineTail : diffDeadline;
    }

    const hours = Math.trunc(deadline / 60);
    const minutes = deadline % 60;

    return { hours, minutes };
  }
}
